
import axios from 'axios';
import _ from 'lodash';
import qs from 'qs';
import React, { Component } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

const StyledAutocomplete = styled(Autocomplete)`
  .MuiTextField-root {
    margin-bottom: 0;
  }
`;


export class AutocompleteMultipleWidget2 extends Component {

  static defaultProps = {
    optionLabel: 'name'
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedOptions: [],
      options: [],
      filter: {},
      loading: false
    }
  }

  handleChange = (e, options) => {
    const { onChange } = this.props;
    this.setState({
      selectedOptions: options
    });
    let optionsId = [];
    options.forEach(option => optionsId.push(option.id));
    onChange(options, optionsId);
  };

  handleOptionSelected = (option, value) => {
    if (value) {
      return option.id === value.id;
    }
    return false;
  };

  getOptionLabel = (option) => {
    const { optionLabel } = this.props;
    if (_.isObject(option))
      return option[optionLabel];
  };

  isNonEmptyValue = (value) => value && _.isArray(value) && value.length > 0;

  loadSelectedOption = (values) => {
    const { url } = this.props;
    if (this.isNonEmptyValue(values)) {
      this.setState({
        loading: true
      });
      const ids = values.map((item) => _.isObject(item) ? item.id : item);
      axios.get(url, {
        params: {id: ids},
        paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
        },
      }).then(res => {
        const options = res.data.results;
        this.setState({
          selectedOptions: options,
          loading: false
        })
      });
    }
  };

  findOption = (value) => {
    const { options } = this.state;
    return _.find(options, {id: value});
  };

  componentDidMount() {
    const { value } = this.props;
    if (this.isNonEmptyValue(value)) {
      this.loadSelectedOption(value);
    }
    this.loadOptions();
  }

  loadOptions = async (otherFilter) => {
    const { filter, url } = this.props;

    let options = [];
    this.setState({
      loading: true
    });

    const load = async () => {
      return axios.get(url, {
        params: {...filter, ...otherFilter},
        paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
        },
      }).then(res => {
        const data = res.data;
        if (data && data.results) {
          options = data.results;
        }
      });
    };

    await load();

    this.setState({
      loading: false,
      options: options
    });
  };

  handleInputChange = (e, value, reason) => {
    if (reason === 'input') {
      this.loadOptions({q: value});
    }
  };

  render() {
    const { label, placeholder, size } = this.props;
    const { options, loading, selectedOptions } = this.state;

    return (
      <StyledAutocomplete
        multiple
        options={options}
        loading={loading}
        value={selectedOptions}
        getOptionSelected={this.handleOptionSelected}
        getOptionLabel={(option) => this.getOptionLabel(option)}
        onInputChange={(e, value, reason) => this.handleInputChange(e, value, reason)}
        size={size}
        filterOptions={(options, state) => options}
        onChange={(e, newValue) => this.handleChange(e, newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={placeholder}
          />
        )}
      />
    )
  }
}